import React, { useEffect, useRef } from "react";
import './sidebarNew.scss';
import { useRouteMatch } from 'react-router-dom';
import NavItems from "./NavItem";
import DashboardIcon from '@material-ui/icons/Dashboard';
import { CaretLeftIcon, CaretRightIcon, XIcon } from "@phosphor-icons/react";
import FlexColumn from "../../../components/FlexBox/FlexColumn";
import FlexRow from "../../../components/FlexBox/FlexRow";
import PeopleIcon from '@material-ui/icons/People';
import PersonIcon from '@material-ui/icons/Person';
import CompanyLogo from '../../../assets/images/logo.png'
import useIsMobile from "../../../hooks/useIsMobile";
import SButton from "../../../components/SButton/SButton";


const SideBarNew = ({ sidebarOpened, changeSidebarState }) => {

    const isMobile = useIsMobile();

    const changeSidebarStateRef = useRef(changeSidebarState);

    useEffect(() => {
        changeSidebarStateRef.current = changeSidebarState;
    }, [changeSidebarState]);

    useEffect(() => {
        if (!sidebarOpened || !isMobile) return;

        if (window.location.hash !== "#sidebar") {
            window.location.hash = "sidebar";
        }

        const handleHashChange = () => {
            if (window.location.hash !== "#sidebar" && changeSidebarStateRef.current) {
                changeSidebarStateRef.current(false);
            }
        };

        window.addEventListener("hashchange", handleHashChange);

        return () => {
            window.removeEventListener("hashchange", handleHashChange);

            if (window.location.hash === "#sidebar") {
                window.history.back();
            }
        };
    }, [sidebarOpened, isMobile]);


    return (
        <>
            {sidebarOpened && isMobile && (
                <div
                    onClick={() => changeSidebarState(false)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'transparent',
                        zIndex: 100,
                        cursor: 'pointer'
                    }}
                />
            )}

            <FlexColumn justifyContent="flex-start" className={`${sidebarOpened ? 'sidebar' : 'collapsed'} sidebar-new`}>

                <FlexColumn gap="0rem" flexWrap="nowrap" justifyContent="start" styles={{ height: '100%', position: 'relative' }}>
                    <FlexColumn styles={{ padding: '0.5rem' }}>
                        <img
                            style={{ marginTop: '1rem', height: '4rem' }}
                            src={CompanyLogo}
                            alt={"Spintly"}
                        />
                        <div className={`${sidebarOpened ? 'sd-opened' : ''} s-divider`} />
                    </FlexColumn>
                    <FlexColumn gap="0.8rem" flexWrap="nowrap" justifyContent="start" styles={{ padding: '0 1rem', overflowY: 'auto', overflowX: 'hidden', marginBottom: '4rem', marginTop: '1rem' }}>

                        <NavItems to={'/dashboard/home'} name="Dashboard" Icon={<DashboardIcon />} opened={sidebarOpened} onClick={isMobile ? () => { changeSidebarState(false) } : undefined} />
                        <NavItems to={'/customer'} name="Customers" Icon={<PeopleIcon />} opened={sidebarOpened} onClick={isMobile ? () => { changeSidebarState(false) } : undefined} />
                        <NavItems to={'/user/list'} name="Users" Icon={<PersonIcon />} opened={sidebarOpened} onClick={isMobile ? () => { changeSidebarState(false) } : undefined} />

                    </FlexColumn>
                </FlexColumn>
                {!isMobile ? <FlexRow className={`sidebar-toggle ${!sidebarOpened ? 'st-closed' : 'st-opened'}`} onClick={() => { changeSidebarState(!sidebarOpened) }}>
                    <CaretLeftIcon className={`carte-rotate-initial ${sidebarOpened ? "cr-rotate-l" : ""}`} weight="bold" size={16} />
                    <CaretRightIcon className={`carte-rotate-initial ${sidebarOpened ? "cr-rotate-r" : ""}`} weight="bold" size={16} />
                </FlexRow> :
                    <SButton onClick={() => { changeSidebarState(!sidebarOpened) }} size="large" variant={"tertiary"} color={"grey"} style={{ position: 'absolute', right: '0.5rem', top: '1rem', fontSize: '1.5rem' }}><XIcon /></SButton>
                }
            </FlexColumn >
        </>
    )
};

export default SideBarNew;